// package imports
import React from 'react';

// CSS imports
import './SignupHint.css';

const SignupHint: React.FC = () => {
  return (
    <div className='SignupHint'>
      <div className='modal-header'>
        <h1>Sign up</h1>
      </div>
      <span className='hint-text'>
        Your account will be activated when your request is accepted
      </span>
    </div>
  );
};

export default SignupHint;
